import axios from 'axios'
import { withHeadersInstance } from './api-instance'
import qs from 'qs'

const baseUrl = process.env.VUE_APP_URL_API

axios.defaults.headers.common = {
    'Content-Type': 'application/json',
}

export const GetClient = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/client/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PutClient = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/client/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const DeleteClient = async function(parameters) {
    try {
        const { publicId } = parameters

        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/client/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetList = async function(locationId, parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)

        const url = `${baseUrl}/clients${queryUrl}`

        return await withHeadersInstance({
            method: 'get',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PostClient = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/client`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetListByClient = async function(locationId, parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)

        const url = `${baseUrl}/locations/client/${locationId}${queryUrl}`

        return await withHeadersInstance({
            method: 'get',
            url: url,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}